import axios from 'axios';

const API_BASE = '/api/inventory';

export const inventoryService = {
  getTransactions: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/transactions`, { params });
    return response.data;
  },

  getLowStock: async () => {
    const response = await axios.get(`${API_BASE}/low-stock`);
    return response.data;
  },

  receiveIntoStock: async (receiverId) => {
    const response = await axios.post(`${API_BASE}/receive-into-stock`, { receiverId });
    return response.data;
  },

  createAdjustment: async (partId, quantityDelta, reason, notes) => {
    const response = await axios.post(`${API_BASE}/adjustments`, {
      partId,
      quantityDelta,
      reason: reason || undefined,
      notes: notes || undefined
    });
    return response.data;
  },

  returnToStock: async (workOrderItemId, quantity, reason, notes) => {
    const response = await axios.post(`${API_BASE}/return-to-stock`, {
      workOrderItemId,
      quantity,
      reason: reason || undefined,
      notes: notes || undefined
    });
    return response.data;
  }
};
